import React from "react"
import { FormattedMessage } from "react-intl"

const startLanguage = {
  disclaimer: variation => {
    switch (variation) {
      default:
        const message =  "This tool is not a substitute for professional medical advice, " +
        "diagnosis, or treatment. If you are experiencing a life-threatening " +
        "emergency that requires immediate attention please call 911 or the " +
        "number for your local emergency service."
        return (
          <FormattedMessage
          id="nav.banner.emergency.disclaimer"
          defaultMessage={message}
        />
        )
    }
  },
  header: (variation, diagnosis) => {
    switch (variation) {
      case "simple":
        return `Let’s assess your risk for ${diagnosis}`
      default:
        return (
          <React.Fragment>
            You're in the right place.
            <br />
            Let's get you feeling better.
          </React.Fragment>
        )
    }
  },
  subheader: variation => {
    switch (variation) {
      default:
    }
  },
  body1: variation => {
    switch (variation) {
      default:
    }
  },
  body2: variation => {
    switch (variation) {
      default:
    }
  },
  body3: variation => {
    switch (variation) {
      default:
    }
  },
  footer: variation => {
    switch (variation) {
      default:
    }
  },
}

export { startLanguage as default }



// WEBPACK FOOTER //
// ./assets/integration/startLanguage.js